import { IArticleCreatedBy } from '../interfaces/query/article-created-by.query.interface';

export class ArticleCreatedBy {
    id: string;
    firstName: string;
    lastName: string;

    constructor(postingQuery?: IArticleCreatedBy) {
        if (postingQuery) {
            this.id = postingQuery.id.toString();
            this.firstName = postingQuery.first_name;
            this.lastName = postingQuery.last_name;
        }
    }
}
